import { useCallback } from 'react';
import useSaveExercise from './useSaveExercise';
import { getNowHHmm } from '../../../helpers';

/**
 * Hook for saving custom "own" exercises with manual kcal, duration and time.
 */
const useSaveOwnExercise = ({
    currentDay,
    exerciseForm,
    onAddSavedExercise,
    setExerciseForm,
    setIsManualAdd
}) => {
    const { saveExercise, isSaving, isSuccess, isError, error, reset } = useSaveExercise(currentDay);

    const saveOwnExercise = useCallback(async () => {
        const { name, comment, kcal, time, duration } = exerciseForm;
        if (!kcal) return;

        const payload = {
            exercise_type: 3,
            exercise_name: name?.trim() || '',
            exercise_kcal: Number(kcal),
            exercise_duration: duration ? Number(duration) : null,
            exercise_time: time || getNowHHmm(),
            exercise_comment: comment?.trim() || ''
        };

        try {
            await saveExercise(payload);

            onAddSavedExercise({
                name: name?.trim() || '',
                comment: comment?.trim() || '',
                kcal: Number(kcal),
                time: time || getNowHHmm(),
                duration: duration ? Number(duration) : null
            });

            setExerciseForm({ name: '', duration: '', kcal: '', time: '', comment: '' });
            setIsManualAdd(false);

            reset();
        } catch (err) {
            console.error('Failed to save own exercise:', err);
        }
    }, [exerciseForm, saveExercise, onAddSavedExercise, setExerciseForm, setIsManualAdd, reset]);
    return { saveOwnExercise, isSaving, isSuccess, isError, error, reset };
};

export default useSaveOwnExercise;
